import { Card, Col, DatePicker, Form, Radio, Row } from 'antd'

import { ClassifierCategory, ClassifierType } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { ClassifierInfiniteSelect } from 'src/components'
import { useClassifierId } from 'src/hooks'
import { disabledFutureDate } from 'src/libs'
import { useLocales } from 'src/locales'

export const SidaDiagnosisCard = () => {
  const { t } = useLocales()

  const classifierId = useClassifierId(
    ClassifierType.SIDA_AIDS_ESTABLISHMENT_REASON,
    ClassifierCategory.TREATMENT
  )

  return (
    <Card title={t('sida_notification.sida_diagnosis')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Form.Item
            name={['sidaStageDate']}
            label={t('sida_notification.sida_stage_date')}
            rules={requiredRules}
          >
            <DatePicker
              className="full-width"
              disabledDate={disabledFutureDate}
              placeholder={t('sida_notification.sida_stage_date')}
            />
          </Form.Item>
        </Col>

        <Col span={16}>
          <Form.Item
            name={['sidaStageReasonIds']}
            label={t('sida_notification.sida_stage_reason')}
            rules={requiredRules}
          >
            <ClassifierInfiniteSelect
              id={classifierId}
              mode="multiple"
              placeholder={t('sida_notification.sida_stage_reason')}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={['arvTreatmentAtDiagnosis']}
            label={t('sida_notification.arv_treatment_at_diagnosis')}
            rules={requiredRules}
          >
            <Radio.Group>
              <Radio value={true}>{t('sida_notification.yes')}</Radio>
              <Radio value={false}>{t('sida_notification.no')}</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={['statisticsReportDate']}
            label={t('sida_notification.statistics_report_date')}
          >
            <DatePicker
              className="full-width"
              disabledDate={disabledFutureDate}
              placeholder={t('sida_notification.statistics_report_date')}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  )
}
